import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';

import EditablePermissions from './EditablePermissions';
import NonEditablePermissions from './NonEditablePermissions';

const enKeys = {
  name: 'nameEn',
  nationality: 'nationalityEn',
  communityName: 'commUnityNameEn',
  communityName2: 'communityEn',
  district: 'districtNameEn',
  district2: 'districtEn',
  municipality: 'municipalityNameEn',
  municipality2: 'muncipalityEn',
  groupName: 'groupNameEn',
  serviceName: 'serviceNameEn',
  stepName: 'stepNameE',
};

const arKeys = {
  name: 'nameAr',
  nationality: 'nationalityAr',
  communityName: 'commUnityNameAr',
  communityName2: 'communityAr',
  district: 'districtNameAr',
  district2: 'districtAr',
  municipality: 'municipalityNameAr',
  municipality2: 'muncipalityAr',
  groupName: 'groupNameAr',
  serviceName: 'serviceNameAr',
  stepName: 'stepNameA',
};

function Permissions({ isEditable, permissions, selectedPermissions, handleCheck }) {
  if (!isArray(permissions?.groupPermissions) || isEmpty(permissions?.groupPermissions)) return null;

  const { locale } = useSelector(state => state.language);

  const langKeys = locale === 'en' ? enKeys : arKeys;

  return isEditable ? (
    <EditablePermissions
      {...{
        langKeys,
        permissions,
        selectedPermissions,
        changePermissionsHandler: handleCheck,
      }}
    />
  ) : (
    <NonEditablePermissions
      {...{
        langKeys,
        permissions,
        selectedPermissions,
        locale,
      }}
    />
  );
}

Permissions.propTypes = {
  isEditable: PropTypes.bool.isRequired,
  permissions: PropTypes.object.isRequired,
  selectedPermissions: PropTypes.array.isRequired,
  handleCheck: PropTypes.func.isRequired,
};

export default memo(Permissions);
